import React, { useState } from "react";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../config/firebaseConfig";

function TeacherLogin() {
  const [tab, setTab] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Login handler
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    const auth = getAuth();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Check if teacher exists in Firestore
      const q = query(collection(db, "teachers"), where("email", "==", email));
      const snap = await getDocs(q);
      if (snap.empty) {
        setMsg("No teacher account found for this email.");
      } else {
        setMsg("Login successful!");
        navigate("/teacher-dashboard"); // Change as needed
      }
    } catch (err) {
      setMsg(err.message);
    }
    setLoading(false);
  };

  // Signup handler
  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    const auth = getAuth();
    try {
      const userCred = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCred.user;
      // Add teacher to Firestore
      await addDoc(collection(db, "teachers"), {
        uid: user.uid,
        name,
        email,
        subject,
      });
      setMsg("Signup successful! Please login.");
      setTab("login");
      setName("");
      setSubject("");
      setPassword("");
    } catch (err) {
      setMsg(err.message);
    }
    setLoading(false);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "#16355C" }}
    >
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md">
        <h2
          className="text-2xl font-bold text-center mb-6"
          style={{ color: "#16355C" }}
        >
          Teacher Login / Signup
        </h2>
        <div className="flex justify-center mb-6">
          <button
            className={`px-4 py-2 rounded-l-lg ${
              tab === "login"
                ? "bg-[#16355C] text-white"
                : "bg-blue-100 text-[#16355C]"
            }`}
            onClick={() => setTab("login")}
          >
            Login
          </button>
          <button
            className={`px-4 py-2 rounded-r-lg ${
              tab === "signup"
                ? "bg-[#16355C] text-white"
                : "bg-blue-100 text-[#16355C]"
            }`}
            onClick={() => setTab("signup")}
          >
            Signup
          </button>
        </div>
        {tab === "login" && (
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold mb-1">Email</label>
              <input
                type="email"
                className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#16355C]"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1">
                Password
              </label>
              <input
                type="password"
                className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#16355C]"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-[#16355C] text-white py-2 rounded font-semibold hover:bg-blue-900 transition"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        )}
        {tab === "signup" && (
          <form onSubmit={handleSignup} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold mb-1">Name</label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1">Email</label>
              <input
                type="email"
                className="w-full border rounded px-3 py-2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1">
                Password
              </label>
              <input
                type="password"
                className="w-full border rounded px-3 py-2"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1">
                Subject
              </label>
              <input
                type="text"
                className="w-full border rounded px-3 py-2"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-[#16355C] text-white py-2 rounded font-semibold hover:bg-blue-900 transition"
              disabled={loading}
            >
              {loading ? "Signing up..." : "Signup"}
            </button>
          </form>
        )}
        {msg && (
          <div className="mt-4 text-center text-sm text-red-600">{msg}</div>
        )}
      </div>
    </div>
  );
}

export default TeacherLogin;
